<template>
  <div>
    <transition
      enter-active-class="transition-opacity duration-300"
      leave-active-class="transition-opacity duration-300"
      enter-class="opacity-0"
      leave-to-class="opacity-0"
      mode="out-in"
    >
      <Cargando v-if="isLoading" />
      <div v-else class="space-y-10">
        <div class="space-y-4">
          <div class="flex items-center space-x-2">
            <span>
              Se muestran facturas entre
              <span class="whitespace-nowrap">{{ facturasDesde | date }}</span>
              y
              <span class="whitespace-nowrap">{{ facturasHasta | date }}</span>
            </span>
            <button
              class="text-gray-400"
              title="Mostrar/esconder filtros"
              @click="showFiltrosFacturas = !showFiltrosFacturas"
            >
              <OutlineCogIcon class="h-6 w-6" />
            </button>
          </div>
          <transition
            enter-active-class="transform transition duration-300"
            enter-class="-translate-y-1/2 scale-y-0 opacity-0"
            enter-to-class="translate-y-0 scale-y-100 opacity-100"
            leave-active-class="transform transition duration-300"
            leave-class="translate-y-0 scale-y-100 opacity-100"
            leave-to-class="-translate-y-1/2 scale-y-0 opacity-0"
          >
            <div
              v-if="showFiltrosFacturas"
              class="flex flex-col items-center gap-4 border-b border-gray-200 pb-6 sm:flex-row sm:items-end sm:gap-6"
            >
              <div class="flex space-x-4">
                <div>
                  <label
                    for="facturas-desde"
                    class="text-sm font-medium tracking-wide text-gray-700"
                  >
                    <span>Fecha desde</span>
                  </label>
                  <datetime
                    class="theme-colescba"
                    type="date"
                    input-id="facturas-desde"
                    input-class="block w-44 sm:text-sm  transition duration-150 ease-in-out"
                    v-model="filtrosFacturas.fechaDesde"
                    zone="America/Argentina/Buenos_Aires"
                    value-zone="America/Argentina/Buenos_Aires"
                    format="dd/MM/yyyy"
                    :phrases="{ ok: 'Aceptar', cancel: 'Cancelar' }"
                  />
                </div>
                <div>
                  <label
                    for="facturas-hasta"
                    class="text-sm font-medium tracking-wide text-gray-700"
                  >
                    <span>Fecha hasta</span>
                  </label>
                  <datetime
                    class="theme-colescba"
                    type="date"
                    input-id="facturas-hasta"
                    input-class="block w-44 sm:text-sm  transition duration-150 ease-in-out"
                    v-model="filtrosFacturas.fechaHasta"
                    zone="America/Argentina/Buenos_Aires"
                    value-zone="America/Argentina/Buenos_Aires"
                    format="dd/MM/yyyy"
                    :phrases="{ ok: 'Aceptar', cancel: 'Cancelar' }"
                  />
                </div>
              </div>
              <button
                @click="getFacturas()"
                class="inline-flex items-center justify-center space-x-2 rounded-md border border-blue-brand-500 bg-white px-3 py-2 text-base font-medium text-blue-brand-500 shadow-sm transition duration-150 ease-in-out hover:bg-blue-brand-100 hover:text-blue-brand-500 focus:outline-none focus:ring focus:ring-blue-200 focus:ring-opacity-50 active:bg-blue-brand-300 active:text-blue-brand-500 sm:text-sm"
              >
                <span>Aplicar</span>
              </button>
            </div>
          </transition>
          <div class="flex flex-col items-center space-y-2 md:flex-row md:space-x-6 md:space-y-0">
            <label
              for="factura"
              class="relative block w-44 text-sm font-medium tracking-wide text-gray-700"
            >
              <span>Factura de América</span> <span class="absolute top-0 ml-px text-xs">*</span>
            </label>
            <select
              class="mt-1 block w-60 appearance-none transition duration-150 ease-in-out sm:text-sm"
              :class="{ 'form-input-invalid text-gray-700': !factura }"
              id="factura"
              v-model="factura"
            >
              <option :value="null" selected disabled>Seleccione de la lista</option>
              <option
                v-for="factura in facturas"
                :key="factura.factura_codigo + factura.factura_numero"
                :value="factura"
              >
                {{ factura.factura_codigo.toUpperCase() }} {{ factura.factura_numero }}
              </option>
            </select>
            <p v-if="factura" class="mt-2 space-x-2 text-sm text-gray-700">
              <span class="space-x-1">
                <span class="font-semibold">Monto</span>
                <span>{{ factura.total | currency }}</span>
              </span>
              <span class="space-x-1">
                <span class="font-semibold">Fecha</span>
                <span>{{ factura.fecha }}</span>
              </span>
            </p>
            <p v-else class="mt-2 text-xs font-semibold text-red-600">La factura es requerida</p>
          </div>

          <ComprobantesFactura
            v-if="factura"
            :facturaCodigo="factura.factura_codigo"
            :facturaNumero="factura.factura_numero"
            :sede="comprobanteTerceros.sede"
            :key="factura.factura_codigo + factura.factura_numero"
          />

          <div class="space-y-2 md:flex md:items-center md:space-x-6 md:space-y-0">
            <label for="observaciones" class="w-44 text-sm font-medium tracking-wide text-gray-700">
              <span>Observaciones</span>
            </label>
            <div class="w-full max-w-xl sm:w-5/6">
              <textarea
                v-model="observaciones"
                id="observaciones"
                maxlength="255"
                class="block w-full rounded-md shadow-sm transition duration-200 ease-in-out sm:text-sm"
              />
            </div>
          </div>
        </div>

        <div class="flex justify-center">
          <button
            class="inline-flex items-center space-x-2 rounded-md px-5 py-2 text-sm font-medium uppercase tracking-wide text-white transition duration-150 ease-in-out focus:outline-none"
            :class="
              formValid
                ? 'bg-colescba-blue-500 hover:bg-colescba-blue-600 focus:ring-1 focus:ring-colescba-blue-500 focus:ring-offset-1'
                : 'cursor-not-allowed bg-gray-400'
            "
            @click="showConfirmModal = true"
            :disabled="!formValid"
            type="button"
          >
            Asociar y marcar como usado
          </button>
        </div>
      </div>
    </transition>

    <ConfirmationModal
      :isOpen="showConfirmModal"
      @save="marcarUsoComprobante"
      @modal:cancel="showConfirmModal = false"
    >
      <span v-if="comprobante && facturaString">
        Se registrará el uso del comprobante {{ comprobante.numero_comprobante }} y se asociará a la
        factura {{ facturaString }}.
      </span>
    </ConfirmationModal>
  </div>
</template>

<script>
import { useService } from '@colescba/app-vue'
import { useSession } from '@colescba/ui'

import moment from 'moment'

import Cargando from '@/components/Core/Cargando'
import ConfirmationModal from '@/components/Core/ConfirmationModal'
import ComprobantesFactura from './ComprobantesFactura'

const facturasSearchDays = process.env.VUE_APP_FACTURAS_SEARCH_DAYS

export default {
  components: { Cargando, ConfirmationModal, ComprobantesFactura },

  props: { comprobanteTerceros: { type: Object, required: true } },

  mixins: [useService('portalPagos'), useSession()],

  data() {
    return {
      isLoading: true,
      factura: null,
      facturas: [],
      observaciones: null,
      showConfirmModal: false,
      facturasDesde: null,
      facturasHasta: null,
      showFiltrosFacturas: false,
      filtrosFacturas: {
        fechaDesde: moment().subtract(facturasSearchDays, 'days').toISOString(),
        fechaHasta: moment().toISOString(),
      },
    }
  },

  mounted() {
    this.getFacturas()
  },

  computed: {
    comprobante() {
      return this.comprobanteTerceros?.comprobante
    },
    formValid() {
      return this.factura ? true : false
    },
    facturaString() {
      return this.factura?.factura_codigo
        ? `${this.factura.factura_codigo.trim().toUpperCase()} ${this.factura.factura_numero}`
        : null
    },
  },

  methods: {
    async marcarUsoComprobante(done) {
      try {
        await this.portalPagos.patchUsoComprobante(
          this.user.cuitCuil.numero,
          this.comprobante.numero_comprobante,
          {
            uso_id: 'USADO',
            factura_codigo: this.factura?.factura_codigo,
            factura_numero: this.factura?.factura_numero,
            observaciones: this.observaciones,
          }
        )

        done()
        this.$emit('reload')

        this.$toast.open({
          message: 'El comprobante fue asociado correctamente y se marcó como usado.',
          type: 'success',
          duration: 2500,
          dismissible: true,
        })
      } catch (e) {
        console.log(e)
        done('Ocurrió un error al procesar la información.')
      }
    },
    async getFacturas() {
      this.isLoading = true
      this.facturas = await this.portalPagos.getFacturas(this.user.cuitCuil.numero, {
        fechaDesde: moment(this.filtrosFacturas.fechaDesde).format('DD-MM-YYYY'),
        fechaHasta: moment(this.filtrosFacturas.fechaHasta).format('DD-MM-YYYY'),
        montoDesde: 0,
        montoHasta: 99999999,
      })
      this.facturasDesde = this.filtrosFacturas.fechaDesde
      this.facturasHasta = this.filtrosFacturas.fechaHasta
      this.isLoading = false
    },
  },
}
</script>
